
import { Component, computed, input, output } from '@angular/core'

import { FlxButtonModule } from '@flowx/angular-ui-toolkit'
import { ContextDocumentContent } from '@flowx/designer/modules/ai/agents/documents/api/documents.api'
import { ConversationDocument } from '@flowx/designer/modules/ai/conversation/ai-conversation.dictionary'
import { AiDocumentContentType } from '@flowx/designer/modules/ai/types/ai.types'

const resourceTypeToLabelMap: Record<AiDocumentContentType, string> = {
  [AiDocumentContentType.BUSINESS_PROCESS]: 'Process',
  [AiDocumentContentType.SCREEN_NAME]: 'UI',
  [AiDocumentContentType.BUSINESS_RULE]: 'Business Rule',
  [AiDocumentContentType.COMPLIANCE_CHECK]: 'Compliance Check',
}

@Component({
  selector: 'flx-document-resource-list',
  templateUrl: './document-resource-list.component.html',
  imports: [FlxButtonModule],
})
export class DocumentResourceListComponent {
  selectedDocument = input<ConversationDocument>(null)
  type = input<AiDocumentContentType>()
  resources = computed(() =>
    this.selectedDocument()?.content.filter(
      (c) => c.type === (this.type() || AiDocumentContentType.BUSINESS_PROCESS)
    )
  )
  label = computed(
    () => resourceTypeToLabelMap[this.type() || AiDocumentContentType.BUSINESS_PROCESS]
  )
  closed = output<{ document: ConversationDocument; resource: ContextDocumentContent } | null>()

  AiDocumentContentType = AiDocumentContentType

  onResourceClick(resource: any): void {
    this.closed.emit({ document: this.selectedDocument(), resource })
  }

  onCloseClick(): void {
    this.closed.emit(null)
  }
}
